import { useFormikContext } from "formik";
import React from "react";

export type FormikObserveState = {
  isSubmitting: boolean;
  dirty: boolean;
  isValid: boolean;
  isValidating: boolean;
};

export function FormikStateObserver({
  callback,
}: {
  callback: (state: FormikObserveState) => void;
}) {
  const { isSubmitting, dirty, isValid, isValidating } = useFormikContext();

  React.useEffect(() => {
    callback({ isSubmitting, dirty, isValid, isValidating });
  }, [callback, isSubmitting, dirty, isValid, isValidating]);

  return null;
}
